import { BaseAPI, Configuration } from "../api";
import * as React from "react";
import i18n from "i18next";

import { logoutReasons, useAuth, useGlobalData } from "../contexts";
import { getBaseUrl } from "../baseUrl";

export function getbasicconfig({
  token,
  logout,
}: {
  token: string;
  logout: (reason: logoutReasons) => void;
}): Configuration {
  return {
    basePath: getBaseUrl(),
    headers: {
      app_language: i18n.language,
    },
    beforeRequest(requestInit: RequestInit) {
      if (token) {
        requestInit.headers["authorization"] = "Bearer " + token;
      }
      return Promise.resolve(requestInit);
    },
    afterRequest(response) {
      if (response.status === 401) {
        logout("UNAUTHORIZED");
      } else if (response.status === 403) {
        logout("FORBIDDEN");
      }
      return Promise.resolve(response);
    },
  };
}

export function useApiService<T extends BaseAPI>(type: new (configuration: Configuration) => T): T {
  const { user, logout } = useAuth();
  const globalData = useGlobalData();
  const languageId = React.useMemo(() => globalData?.currentLanguage?.languageId, [globalData]);

  const configuration = React.useMemo(() => {
    let cfg = getbasicconfig({
      token: user?.token,
      logout,
    });
    cfg.headers["app_language_id"] = languageId ?? 2;
    return cfg;
  }, [languageId, logout, user]);

  return React.useMemo(() => new type(configuration), [configuration, type]);
}
